import { useState } from "react";

export default function useLocalState(name, initialState) {
  const [state, setState] = useState(
    (isBrowser() && JSON.parse(localStorage.getItem(name))) || initialState
  );
  function setNewState(newItem) {
    isBrowser() && localStorage.setItem(name, JSON.stringify(newItem));
    setState(newItem);
  }
  return [state, setNewState];
}
export const isBrowser = () => typeof window !== "undefined";
